import axiosInstance from "./axiosInstance";

const getCustomerServices = async () => {
  const response = await axiosInstance.get(
    "partner-service/customer/all/subscribtion"
  );
  return response.data;
};

const activateCustomer = async (customerId: string) => {
  const response = await axiosInstance.patch(`customer/activate/${customerId}`);
  return response.data;
};
const deActivateCustomer = async (customerId: string) => {
  const response = await axiosInstance.patch(
    `customer/desactivate/${customerId}`
  );
  return response.data;
};

const ActivateService = async (
    subscriptionId: string,
  customerId: string
) => {
  const response = await axiosInstance.post(
    "partner-service/customer/subscribe",
    { subscriptionId, customerId }
  );
  return response.data;
};
const DeactivateService = async (subscriptionId: string) => {
  const response = await axiosInstance.post(
    "partner-service/customer/unsubscribe",
    { subscriptionId }
  );
  return response.data;
};
const configCustomerRate = async (
  partnerServiceId: string,
  customerId: string,
  customRate?: number,
  forcePartner?: boolean
) => {
  const response = await axiosInstance.post("partner-service/customer/assign", {
    partnerServiceId,
    customerId,
    customRate,
    forcePartner,
  });
  return response.data;
};

const deletePartnerService = async (partnerServiceId: string) => {
  const response = await axiosInstance.delete(
    `partner-service/delete/${partnerServiceId}`
  );
  return response.data;
}

const updateCustomerSubscriptionRate = async (
    subscriptionId: string,
  customerId: string,
  rate: number
) => {
  const response = await axiosInstance.patch(
    `partner-service/customer/${customerId}/subscription/${subscriptionId}/rate`,
    { rate }
  );

  return response.data;
}

const updateCustomerForcePartner = async (
  partnerServiceId: string,
  customerId: string,
  forcePartner: boolean,
  subscriptionId: string,
) => {
  const response = await axiosInstance.patch(
    `partner-service/customer/${customerId}/subscription/${subscriptionId}/force-partner`,
    { forcePartner, partnerServiceId }
  );
  return response.data;
}

const getTotalCustomer = async () => {
  const response = await axiosInstance.get("customer/total");
  return response.data;
};

const getBalance = async () => {
  const response = await axiosInstance.get(`payments/balance`);
  return response.data;
};

const switchCustomerMode = async (customerId: string) => {
  const response = await axiosInstance.patch(`customer/admin/mode/${customerId}`);
  return response.data;
};

const requestToProduction = async () => {
  const response = await axiosInstance.get(`customer/mode/request`);
  return response.data;
};

const validateProductionRequest = async (customerId: string, approved: boolean, reason?: string) => {
  const response = await axiosInstance.patch(`customer/admin/production-request/${customerId}`, {approved, reason} );
  return response.data;
}

const deleteCustomer = async (customerId: string) => {
  const response = await axiosInstance.delete(`customer/${customerId}`);
  return response.data;
}

export const customerService = {
  getCustomerServices,
  ActivateService,
  DeactivateService,
  configCustomerRate,
  activateCustomer,
  deActivateCustomer,
  getTotalCustomer,
  getBalance,
  switchCustomerMode,
  requestToProduction,
  validateProductionRequest,
  deleteCustomer,
  deletePartnerService,
  updateCustomerSubscriptionRate,
  updateCustomerForcePartner
};
